module.exports = __webpack_public_path__ + "img/bcg-left.fb1d9c39.png";